// import Logo from '../assets/Logo.mp4';
import Logo from '../assets/logo.svg'

function Loading() {
  return (
    <div className="h-[100vh] flex items-center justify-center bg-white px-3">
      <div className="w-fit h-fit text-center">
        {/* <video
          autoPlay
          muted
          loop
          className="h-[100px] sm:h-[200px] object-contain bg-[#f8f8f8] mx-auto rounded-full shadow-xl shadow-slate-200"
          src={Logo}
        /> */}

        <img
          alt="App Logo"
          src={Logo}
          className="h-[100px] sm:h-[130px] w-auto mx-auto"
        />
        <h5 className="text-xl mt-5">
          <span className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-300 to-secondary-300 animate-reveal">
            Hold on!
          </span>{' '}
          Good things takes time
          <span className="inline-block ml-1">
            <span className="dot bounce delay-0 bg-primary-300"></span>
            <span className="dot bounce delay-1 bg-secondary-300"></span>
            <span className="dot bounce delay-2 bg-slate-800"></span>
          </span>
        </h5>

        {/* Inline styles for bounce animation */}
        <style jsx>{`
          .dot {
            display: inline-block;
            width: 6px;
            height: 6px;
            margin: 0 2px;
            border-radius: 50%;
          }

          .bounce {
            animation: bounce 1.2s infinite ease-in-out;
          }

          .delay-0 {
            animation-delay: 0s;
          }

          .delay-1 {
            animation-delay: 0.2s;
          }

          .delay-2 {
            animation-delay: 0.4s;
          }

          @keyframes bounce {
            0%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-8px);
            }
          }
        `}</style>
      </div>
    </div>
  );
}

export default Loading;
